import React, { useState, useEffect } from 'react';
import {menuData} from "../../data/menuData";
// @ts-ignore
const title = menuData[7].children[2].title;
const description = `Locking a transaction means no one can change it, so the financial records 
for that time stay correct and can't be messed with.`;

const chartOfAccounts_images = [
    '/images/accountant/transaction-locking/transaction-locking.png', // 0
    '/images/accountant/transaction-locking/locking-history.png', // 1
    '/images/accountant/transaction-locking/locking-box.png', // 2
];

const topic = [
    {
        title: 'Home',
        description: ``,
        id: 'home',
    },
    {
        title: 'Locking History',
        description: `.`,
        id: 'locking-history',
    },
];

const TransactionLocking: React.FC = () => {
    const [activeId, setActiveId] = useState(topic[0].id);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const newActiveId = entry.target.id;
                        setActiveId(newActiveId);
                        window.history.replaceState(null, '', `#${newActiveId}`);
                    }
                });
            },
            {
                root: null,
                rootMargin: '-50% 0% -50% 0%',
                threshold: 0,
            }
        );

        topic.forEach((item) => {
            const section = document.getElementById(item.id);
            if (section) {
                observer.observe(section);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    const handleItemClick = (id: string) => {
        setActiveId(id);
    };

    return (
        <div className="max-w-4xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">
                {/* Chart of Accounts */}
                <div className="mb-6"   id={topic[0].id}>
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <img
                            src={chartOfAccounts_images[0]}
                            alt={title}
                            className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                    </div>
                </div>

                {/* Locking History */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6"  id={topic[1].id}>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Locking History</h2>
                    <p className="text-gray-600 mb-4">
                        To view a record of all past transaction lockings, simply click the "Locking History" button.
                    </p>
                    <img
                        src={chartOfAccounts_images[1]}
                        alt={title}
                        className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>

                    <p className="text-gray-600 pt-4 mb-4">
                        Clicking the "Locking History" button reveals a dedicated box displaying a
                        vertical timeline of all past transaction lockings, complete with the reason for each lock.
                    </p>
                    <img
                        src={chartOfAccounts_images[2]}
                        alt={title}
                        className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>

                </div>
            </div>

            {/* side route */}
            <div className="fixed w-1/5 right-2">
                <ul>
                    {topic.map((item) => (
                        <li key={item.id} className="mb-4">
                              <span className="text-xs">
                                    <a
                                        className={`hover:text-blue-700 border-l p-4 ${
                                            activeId === item.id ? 'text-blue-700 font-bold border-blue-700' : ''
                                        }`}
                                        href={`#${item.id}`}
                                        onClick={() => handleItemClick(item.id)}
                                    >
                                      {item.title}
                                    </a>
                              </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TransactionLocking;
